<div class="claims">
  <div class="claim" *ngFor="let claim of _mfvClaims; let i = index">
    <div class="claim-info">
      <div class="claim-title">
        {{ claim.contract && claim.contract.full_contract_number ? (("mfv-claim-detail.contract-prefix" | translate) + claim.contract.full_contract_number + ' (' + claim.contract.pet_name +')') : ('mfv-claim-detail.no-contract-assigned' | translate) }}
        ,
        {{ ("mfv-claim-detail.cluster-prefix" | translate) + claim.cmsClusterID }},
        {{ ("mfv-claim-detail.mfv-claim-id-prefix" | translate) + claim.mfvClaimID }}
      </div>
      <ng-container *ngIf="claim.expandedBig">
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.assigned-contract' | translate }}</div>
          <div class="claim-info-value">
            <mat-icon class="contract-link" (click)="openContactInNewTab(claim)">
              link
            </mat-icon>
            {{ claim.contract && claim.contract.full_contract_number ? claim.contract.full_contract_number : ('mfv-claim-detail.no-contract-assigned' | translate) }}
          </div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.mfv-claim-id' | translate }}</div>
          <mat-form-field class="claim-info-value" *ngIf="claim.contract">
            <input matInput [(ngModel)]="claim.mfvClaimID" [tabIndex]="20+i" (blur)="mfvClaimIDSet(claim)" (keydown.tab)="onTabPress(claim)">
          </mat-form-field>
          <mat-icon *ngIf="claim.mfvClaimSystemID" class="contract-link" (click)="openClaimInNewTab(claim)">
            link
          </mat-icon>
          <div class="claim-info-value" *ngIf="!claim.contract">--</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.reserve-claim' | translate }}</div>
          <div class="claim-info-value">{{ claim.mfvReserveClaimSystemID }}</div>
        </div>
        <div class="item" *ngIf="claim.contract?.full_contract_number === this._fnolRequest?.initialReserveData?.fullContractNumber && claim.type === this._fnolRequest?.initialReserveData?.type">
          <mat-label>{{ 'mfv-claim-detail.overwrite-reserve-claim' | translate }}</mat-label>
          <mat-checkbox [(ngModel)]="claim.overwriteReserveClaim" (change)="onOverwriteCheckboxChange($event, i)"></mat-checkbox>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.cluster' | translate }}</div>
          <div class="claim-info-value">{{ claim.cmsClusterID }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.claim-date' | translate }}</div>
          <div class="claim-info-value">{{ claim.claimDate | date:'dd.MM.YYYY' }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.precedent-cluster-id' | translate }}</div>
          <div class="claim-info-value">{{ claim.followUpTreatmentCluster }} <mat-icon class="cluster-warn" color="warn" *ngIf="showClusterWarning(claim)">
            warning
          </mat-icon></div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.precedent-claim-id' | translate }}</div>
          <div class="claim-info-value">{{ claim.followUpTreatmentClaimID }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.notification-date' | translate }}</div>
          <div class="claim-info-value">{{ claim.notificationDate | date:'dd.MM.YYYY' }}</div>
        </div>
        <div class="item" *ngIf="!claim.overwriteReserveClaim">
          <mat-form-field class="multiline">
            <mat-label>{{ 'mfv-claim-detail.course-of-events'|translate }}</mat-label>
            <textarea matInput
                cdkTextareaAutosize
                #autosize="cdkTextareaAutosize"
                cdkAutosizeMinRows="2"
                [(ngModel)]="claim.courseOfEvents"></textarea>
        </mat-form-field>
        </div>
        <hr>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.type' | translate }}</div>
          <div class="claim-info-value">{{ claim.type }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.subtype' | translate }}</div>
          <div class="claim-info-value">{{ claim.subtype }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.cause' | translate }}</div>
          <div class="claim-info-value">{{ claim.cause }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.preexisting-conditions' | translate }}</div>
          <div class="claim-info-value">{{ claim.preexistingCondition | booleanTranslate }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.emergency-abroad' | translate }}</div>
          <div class="claim-info-value">{{ claim.emergencyAbroad | booleanTranslate }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.chronic-disease' | translate }}</div>
          <div class="claim-info-value">{{ claim.chronicDisease | booleanTranslate }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.obligation-fulfilled' | translate }}</div>
          <div class="claim-info-value">{{ claim.obligationsFulfilled | booleanTranslate }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.covered' | translate }}</div>
          <div class="claim-info-value">{{ claim.covered | booleanTranslate }}</div>
        </div>
        <div class="item" *ngIf="!claim.covered">
          <div class="claim-info-title">{{ 'mfv-claim-detail.reason-not-covered' | translate }}</div>
          <div class="claim-info-value">{{ claim.reasonWhyNotCovered }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.cost-coverage-percentage' | translate }}</div>
          <div class="claim-info-value">{{ claim.costCoveragePercentage }}</div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.further-clarification-comment' | translate }}</div>
          <div class="claim-info-value">
            <mat-icon *ngIf="claim.furtherClarificationComment" [title]="'mfv-claim-detail.copy-to-clipboard' | translate" class="copy-to-clipboard"
                      (click)="copyToClipboard(claim.furtherClarificationComment)">
              content_copy
            </mat-icon>
            <span>{{ claim.furtherClarificationComment }}</span>
          </div>
        </div>
        <div class="item">
          <div class="claim-info-title">{{ 'mfv-claim-detail.vet-from-invoice' | translate }}</div>
          <div class="claim-info-value">{{ formatVetFromInvoice() }}</div>
        </div>
        <div>
          <CPF-mfv-claim-calculation-detail [claim]="claim" [index]="i">
          </CPF-mfv-claim-calculation-detail>
        </div>
        <div class="item comment">
          <div class="claim-info-title">{{ 'mfv-claim-detail.comment' | translate }}</div>
          <div class="claim-info-value">
            <mat-icon (click)="copyToClipboard(claim.commentForMfv)" *ngIf="claim.commentForMfv" [title]="'mfv-claim-detail.copy-to-clipboard' | translate"
                      class="copy-to-clipboard">
              content_copy
            </mat-icon>
            <span>{{ claim.commentForMfv }}</span>
          </div>
        </div>
        <div class="item comment">
          <div class="claim-info-title">{{ 'mfv-claim-detail.comment-2' | translate }}</div>
          <div class="claim-info-value">
            <mat-icon (click)="copyToClipboard(claim.commentForMfv2)" *ngIf="claim.commentForMfv2" [title]="'mfv-claim-detail.copy-to-clipboard' | translate"
                      class="copy-to-clipboard">
              content_copy
            </mat-icon>
            <span>{{ claim.commentForMfv2 }}</span>
          </div>
        </div>
        <div class="item" style="margin-top: 20px;">
          <div class="claim-info-title">{{ 'mfv-claim-detail.reason-for-visit' | translate }}</div>
          <mat-form-field class="claim-info-value" [class.invalid-field]="isReasonForVisitInvalid(claim)">
            <input matInput [(ngModel)]="claim.reasonForVisitTranslated" [tabIndex]="100+i" (blur)="reasonForVisitTranslatedChanged(claim)" (input)="onReasonForVisitInput(claim)" (focus)="onReasonForVisitFocus(claim)">
          </mat-form-field>
        </div>
        <div class="item" *ngIf="claim.totalNonCoveredAmount > 0" style="margin-top: 20px;">
          <div class="claim-info-title">{{ 'mfv-claim-detail.reason-not-covered' | translate }}</div>
          <mat-form-field class="claim-info-value" [class.invalid-field]="isReasonNotCoveredInvalid(claim)">
            <input matInput [(ngModel)]="claim.reasonNotCoveredTextTranslated" [tabIndex]="101+i" (blur)="reasonNotCoveredTextTranslatedChanged(claim)" (input)="onReasonNotCoveredInput(claim)" (focus)="onReasonNotCoveredFocus(claim)">
          </mat-form-field>
        </div>
      </ng-container>
    </div>
    <div class="actions">
      <mat-icon (click)="toggleExpandClaim(claim)" class="expand-button" [class.expand]="!claim.expandedBig">expand_less</mat-icon>
    </div>

    <div>
      <button (click)="createClaimInMfv(claim)" color="primary" mat-raised-button>{{ 'mfv-claim-detail.send-to-mfv' | translate }}
      </button>
      <div *ngIf="claim.type === 'unfall' && claim.overwriteReserveClaim" class="claim-info-value">{{ 'mfv-claim-detail.warning-accident-date' | translate }} <mat-icon class="cluster-warn" color="warn">
        warning
      </mat-icon></div>
    </div>
  </div>
</div>

<div class="claims-actions">
  <button (click)="completeFNOLRequest()" [disabled]="!isCommentGenerated() || !allClaimsValid()" color="primary" mat-raised-button>{{ 'mfv-claim-detail.complete' | translate }}</button>

  <button (click)="generateComments()" [disabled]="!allClaimsValid()" color="primary"
          mat-raised-button>{{ 'mfv-claim-detail.generate-comments' | translate }}
  </button>

  <button (click)="generateDocx()" [disabled]="!isCommentGenerated() || !allClaimsValidForEmailGeneration()" color="accent" mat-raised-button>{{ 'mfv-claim-detail.generate-tables-for-email' | translate }}</button>
  
  <div *ngIf="isCommentGenerated() && allClaimsValid()">
    <mat-form-field appearance="outline">
      <mat-select [(ngModel)]="tableLang">
        <mat-option *ngFor="let lang of languages" [value]="lang">{{ lang }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<!-- Email fields - only visible when send email button is active -->
<div *ngIf="isDocxGenerated" class="email-fields">
  <mat-form-field appearance="outline" class="email-field-small">
    <mat-label>{{ 'mfv-claim-detail.email-recipient' | translate }}</mat-label>
    <input matInput [(ngModel)]="emailRecipient" placeholder="{{ 'mfv-claim-detail.email-recipient' | translate }}">
  </mat-form-field>
  
  <mat-form-field appearance="outline" class="email-field-small">
    <mat-label>{{ 'mfv-claim-detail.email-subject' | translate }}</mat-label>
    <input matInput [(ngModel)]="emailSubject" placeholder="{{ 'mfv-claim-detail.email-subject' | translate }}">
  </mat-form-field>
  
  <mat-form-field appearance="outline" class="email-field-large">
    <mat-label>{{ 'mfv-claim-detail.email-text' | translate }}</mat-label>
    <textarea matInput [(ngModel)]="emailText" placeholder="{{ 'mfv-claim-detail.email-text' | translate }}" rows="8"></textarea>
  </mat-form-field>
  
  <!-- PDF Display Section -->
  <div *ngIf="generatedPdfBlob && generatedPdfFileName" class="pdf-display-section">
    <div class="pdf-icon-container" (click)="downloadPdf()">
      <mat-icon class="pdf-icon">picture_as_pdf</mat-icon>
      <div class="pdf-filename">{{ getTruncatedFileName(generatedPdfFileName) }}</div>
    </div>
    
    <button type="button" mat-stroked-button (click)="fileInput.click()">
      {{ 'mfv-claim-detail.replace-pdf-file' | translate }}
    </button>
    <input #fileInput type="file" accept=".pdf" (change)="onPdfFileSelected($event)" style="display: none;">
  </div>
  
  <div class="email-button-container">
    <button 
      (click)="sendDocxViaEmailWithConfirmation()" 
      [disabled]="isAutomaticEmailSent()" 
      [class.disabled-grey]="isAutomaticEmailSent()"
      color="accent" 
      mat-raised-button>
      {{ 'mfv-claim-detail.send-email-automatically' | translate }}
    </button>
    <div *ngIf="isAutomaticEmailSent()" class="email-sent-timestamp">
      {{ 'mfv-claim-detail.automatic-email-sent-at' | translate:{timestamp: getAutomaticEmailSentTimestamp()} }}
    </div>
  </div>
</div>

<div id="pdf-html-container" [innerHTML]="this.tables">
</div>

<div>
  <button (click)="sendAllStandardDocsToMfv()" [disabled]="!checkReadyToUploadDocsToMfv() || haveDocumentsBeenUploadedToMfv()" color="accent" mat-raised-button>
    {{ 'mfv-claim-detail.send-standard-docs-to-mfv' | translate }}
  </button>
</div>

<div class="logs-upload-documents-to-mfv">
  {{ _fnolRequest?.logsUploadDocumentsToMfv }}
</div>
